'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var S = {};
var SIZES = {
  s: '16px',
  m: '32px',
  l: '64px',
  custom: '100%'
};
var loaderRotate = styled.keyframes(["0%{transform:rotate(0);}100%{transform:rotate(360deg);}"]);
S.Loader = styled__default["default"].div.withConfig({
  displayName: "styles__Loader",
  componentId: "sc-1vd5902-0"
})(["box-sizing:border-box;border-radius:100%;border:2px solid ", ";border-bottom-color:transparent;height:", ";width:", ";background:0 0 !important;display:inline-block;animation:", " 0.75s 0s linear infinite;"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var size = _ref2.size;
  return SIZES[size];
}, function (_ref3) {
  var size = _ref3.size;
  return SIZES[size];
}, loaderRotate);

var Loader = function Loader(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return /*#__PURE__*/React__default["default"].createElement(S.Loader, {
    size: size,
    color: color
  });
};
Loader.propTypes = {
  /** Size */
  size: PropTypes__default["default"].oneOf(['s', 'm', 'l', 'custom']),
  /** Color */
  color: PropTypes__default["default"].string
};
Loader.defaultProps = {
  size: 'm',
  color: '#ffffff'
};

module.exports = Loader;
